import './form-coupon.scss';

import { CouponFormSchema } from "@factory/form/form.rule";
import { ActionEnum } from '@factory/model/actions.enum';
import { CouponTypeEnum } from '@factory/model/coupon-type.enum';
import { useQyGetLevel } from '@factory/query/level.query';
import { LabelValue } from '@shared/models/label-value.interface';
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import DropdownControl from '@shared/ui/hook-form/dropdown-control/dropdown-control';
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = CouponFormSchema;
export function FormCoupon() {
  const { control, watch } = useFormContext<CouponFormSchema>();
  const valueType = watch('valueType');
  const { data: response } = useQyGetLevel("", 9999);
  const levelOption = LabelValue.MapArray(
    response?.data || [],
    (item) => item.name,
    (item) => item.code
  );
  const purposeOptions = [
    {
      label: "Redemption",
      value: ActionEnum.Redeem
    },
    {
      label: "Earning",
      value: ActionEnum.Earn
    }
  ]
  const valueTypeOptions = [
    {
      label: "Percentage",
      value: CouponTypeEnum.Percentage
    },
    {
      label: "Amount",
      value: CouponTypeEnum.Amount
    }
  ]
  return (
    <div id="FormCoupon" className="coupon">
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="couponCode"
        label="Coupon Code (Minimum of 5 characters)"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter couponCode"
      />
      <InputDateControl<InputFormSchema>
        control={control}
        name="validUntil"
        label="Valid Until"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter validUntil"
      />
      <DropdownControl<InputFormSchema>
        control={control}
        name="level"
        label="Level"
        options={levelOption}
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter level"
      />
      <DropdownControl<InputFormSchema>
        control={control}
        name="purpose"
        label="Purpose"
        options={purposeOptions}
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter purpose"
      />
      <DropdownControl<InputFormSchema>
        control={control}
        name="valueType"
        label="Value Type"
        options={valueTypeOptions}
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter purpose"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="points"
        label={`Points ${valueType === CouponTypeEnum.Percentage ? '(%)' : ''}`}
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter points"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="stamps"
        label={`Stamps ${valueType === CouponTypeEnum.Percentage ? '(%)' : ''}`}
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter stamps"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="redeemLimit"
        label="Redeem Limit"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter redeemLimit"
      />
      <CheckboxControl<InputFormSchema>
        control={control}
        name="isUserRedeemable"
        label="Is User Redeemable (Customers can earn points/stamps by themselves)"
        containerClassName="pb-2"
      />
    </div>
  );
}

export default FormCoupon;
